import { COMPANY_LOGO, COMPANY_NAME_FC } from 'config/company.constants'
import { getHostBranding, getTenant, subscribeTenant } from 'config/tenant.runtime'
import { useSyncExternalStore } from 'react'

/**
 * The active tenant, re-rendering when it changes.
 *
 * For the handful of values worth reading at render time rather than at module load. Most
 * branding cannot work this way: COMPANY_TITLE and friends are plain `export const` in roughly a
 * hundred modules, evaluated once when the bundle loads, and making them reactive would mean
 * touching every one of those call sites.
 */
export const useTenant = () => useSyncExternalStore(subscribeTenant, getTenant, () => null)

/**
 * The company logo, picked up without signing in again.
 *
 * Falls back to the value compiled into this build, so a per-tenant build with no runtime tenant
 * resolves exactly what it resolves today.
 */
export const useCompanyLogo = (): string => {
  const tenant = useTenant()
  // Signed in: the tenant's own logo. Not yet: whatever the hostname resolved to, so a
  // customer's login page carries their logo. Otherwise the value compiled into this build.
  return tenant?.logoUrl || getHostBranding()?.logoUrl || COMPANY_LOGO || ''
}

/** The company's short name, same reasoning as the logo. */
export const useCompanyName = (): string => {
  const tenant = useTenant()
  return tenant?.name || getHostBranding()?.title || COMPANY_NAME_FC || ''
}
